import * as i0 from "@angular/core";
var UtilService = /** @class */ (function () {
    function UtilService() {
    }
    /*
      scroll on the container causes weird issue on dialog.
      removing it will disable the global scroll on page.
      and we can implement page level scroll.
    */
    UtilService.prototype.hideScrollOnTopMostContainer = function () {
        var topmostContainer = document.querySelector('.topmost-container');
        if (topmostContainer.classList) {
            topmostContainer.classList.add('hide-scroll');
        }
    };
    UtilService.prototype.removeHideScrollClassFromTopMostContainer = function () {
        var topmostContainer = document.querySelector('.topmost-container');
        if (topmostContainer.classList) {
            topmostContainer.classList.remove('hide-scroll');
        }
    };
    UtilService.prototype.stopEventBubbling = function (event) {
        if (!event) {
            event = window.event;
        }
        event.cancelBubble = true;
        if (event.stopPropogation) {
            event.stopPropogation();
        }
    };
    UtilService.prototype.removeQueryParam = function (entries) {
        if (entries === void 0) { entries = []; }
        var keys = {};
        var search = location.search.substring(1);
        try {
            if (search) {
                var params_1 = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === '' ? value : decodeURIComponent(value); });
                var foundAnyEntry_1 = false;
                entries.forEach(function (entry) {
                    if (params_1[entry]) {
                        foundAnyEntry_1 = true;
                        keys[entry] = params_1[entry];
                        delete params_1[entry];
                    }
                });
                if (!foundAnyEntry_1) {
                    return;
                }
                var href = this.jsonToQueryString(params_1);
                href = href !== '?' ? href : '';
                window.history.replaceState({}, document.title, window.location.pathname + href);
            }
        }
        catch (e) {
            console.error('could not remove param ', e);
            // do nothing
        }
    };
    UtilService.prototype.jsonToQueryString = function (json) {
        return '?' +
            Object.keys(json).map(function (key) {
                return encodeURIComponent(key) + '=' +
                    encodeURIComponent(json[key]);
            }).join('&');
    };
    UtilService.ngInjectableDef = i0.defineInjectable({ factory: function UtilService_Factory() { return new UtilService(); }, token: UtilService, providedIn: "root" });
    return UtilService;
}());
export { UtilService };
